import { Guid } from '@web/utils';
import { ShippingMethodCode } from '@web/shared/module/shop';
import { AdminShippingMethodPrice } from './admin-shipping-method-price';

export class AdminShippingMethodDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeViewed: boolean;
      category: string;
      code: ShippingMethodCode;
      createdAt: Date;
      description: string;
      id: Guid;
      name: string;
      prices: AdminShippingMethodPrice[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get category(): string {
    return this.data.category;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get code(): ShippingMethodCode {
    return this.data.code;
  }

  public get prices(): AdminShippingMethodPrice[] {
    return this.data.prices;
  }
}
